import React, { useEffect } from "react";
import { Box } from "@mui/material";

// Importa los componentes de la carpeta Productos
import Promociones from "../components/Productos/Promociones";
import Catalogos from "../components/Productos/Catalogos";

export default function ProductosPage() {
  useEffect(() => {
    // Al entrar a la página, el scroll sube automáticamente
    window.scrollTo(0, 0);
    document.title = "Productos | Eléctrica GRM";
  }, []);

  return (
    <Box>
      <Promociones />
      <Catalogos />
    </Box>
  );
}
